import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { URL } from '../../link.js';

const Valida = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const validarUsuario = async (id) => {
        try {
            const res = await axios.get(`${URL}/usuario/validarpass/${id}`);
            if (res.data) {
                localStorage.setItem("dataUser", JSON.stringify(res.data))
                navigate("/actualiza");
            }
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        validarUsuario(id);
    }, [id]);

    return (
        <div>
            <h1>Validando usuario. Por favor espere...</h1>
        </div>
    );
}

export default Valida